<template>
    <div class="alert alert-danger d-flex" v-if="spacesWithoutPhotos > 0">
        <div><b v-text="spacesWithoutPhotos"></b> {{ pluralize('Space', spacesWithoutPhotos) }} without Photo.</div>
        <a class="font-weight-bold ml-auto" :href="`/projects/${project.slug}/photos`">Add Photos</a>
    </div>
</template>
<script>
export default {

    props:['status', 'project'],

    data(){
        return {
            spacesWithoutPhotos: this.status,
        }
    },

    created() {
        App.bus.$on('refresh-space-areas', this.resolve)
        App.bus.$on('space-created', this.resolve)
        App.bus.$on('space-updated', this.resolve)
        App.bus.$on('space-deleted', this.resolve)
    },

    methods:{
        resolve(event){
            this.spacesWithoutPhotos = event.spacesWithoutPhotos
        }
    },
}
</script>
